import React from 'react'
import {Card} from "@material-ui/core";

export const CabinetPushElement = ({push}) => (
    <a href="https://app.tonesky.ru/#hot" target="_blank" className="cabinet-push-link" rel="noopener noreferrer">
        <Card className="cabinet-push-message">
            <div className="push-title">Успей взять!</div>
            <div className="push-message">{push.message}</div>
        </Card>
    </a>
);



